module.exports = __webpack_public_path__ + "img/transportation.ff97575a.png";